// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/vico-logo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23d9e1ec%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    font-family: 'Vazirmatn', serif;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.rtl {
    direction: rtl !important;
}

.ltr {
    direction: ltr !important;
}

.auth-logo {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    max-height: 8em;
}

.navbar-nav {
    padding-inline-start: 0;
}

.startbar {
    border-right: 0;
    border-left: 1px solid var(--bs-startbar-e-border-color);
}

.nav-item .nav-link span {
    margin-right: 16px;
}

.form-check-input {
    float: right !important;
    margin-left: 0.5em !important;
    cursor: pointer;
}

.form-check-label {
    cursor: pointer;
}

.form-switch {
    padding-left: 0;
}

.modal-header .btn-close {
    margin: calc(-0.5 * var(--bs-modal-header-padding-y)) auto calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x));
}

.modal-body p {
    text-align: justify;
}

#page-content {
    transition: opacity 0.2s ease-out;
}

.page-is-fading {
    opacity: 0;
}

.managed-alert {
    transition: opacity 0.2s ease-out;
}

.alert-hidden {
    opacity: 0;
    pointer-events: none;
}

.profile-avatar {
    height: 128px;
    width: 128px;
    background-color: var(--bs-card-bg);
}

.vico-animation {
    transition: opacity 0.2s ease-out;
}

.uppy-Dashboard-inner {
    background-color: var(--bs-card-bg) !important;
    border-color: var(--bs-border-color) !important;
}

.uppy-Dashboard-AddFiles-title {
    color: var(--bs-body-color) !important;
}

.uppy-Dashboard-inner {
    width: auto !important;
}

.uppy-Dashboard-browse,
.uppy-StatusBar-actionBtn--done,
.uppy-DashboardTab-iconMyDevice,
.uppy-Dashboard-serviceMsg-actionBtn,
[data-uppy-theme=dark] .uppy-DashboardContent-addMore,
[data-uppy-theme=light] .uppy-DashboardContent-addMore,
[data-uppy-theme=dark] .uppy-DashboardContent-back,
[data-uppy-theme=dark] .uppy-DashboardContent-save,
[data-uppy-theme=light] .uppy-DashboardContent-back,
[data-uppy-theme=light] .uppy-DashboardContent-save {
    color: var(--bs-primary) !important;
}

[data-uppy-theme=dark] .uppy-Dashboard-browse:focus,
[data-uppy-theme=dark] .uppy-Dashboard-browse:hover,
.uppy-ProviderBrowserItem-checkbox:focus,
.uppy-Dashboard-dropFilesHereHint {
    border-color: var(--bs-primary) !important;
}

.uppy-ProviderBrowserItem-checkbox:focus {
    box-shadow: 0 0 0 3px #0d6efd33
}

[data-uppy-theme=dark] .uppy-DashboardContent-bar,
[data-uppy-theme=dark] .uppy-StatusBar {
    background-color: var(--bs-card-bg) !important;
}

.uppy-Root {
    --uppy-c-primary: var(--bs-primary) !important;
    --uppy-c-bg-primary: var(--bs-card-bg) !important;
    --uppy-c-text-primary: var(--bs-body-color) !important;
    --uppy-c-border-primary: var(--bs-border-color) !important;
}

.bg-vico-spring {
    background-color: #0da684A0;
}

.bg-vico-summer {
    background-color: #fff700A0;
}

.bg-vico-autumn {
    background-color: #db8814A0;
}

.bg-vico-winter {
    background-color: #41cbd8A0;
}

.bg-card-quote {
    background-color: #5b58e680;
}

.quote-footer::before {
    content: "— ";
    opacity: 0.8;
}


.card-with-bg-icon {
    position: relative;
    overflow: hidden;
}

.card-with-bg-icon .card-body,
.card-with-bg-icon .card-header {
    position: relative;
    z-index: 1;
    background-color: transparent;
}

.card-with-bg-icon::after {
    font-family: "Line Awesome Free";
    font-weight: 900;
    position: absolute;
    z-index: 0;
    font-size: 10rem;
    color: rgba(var(--bs-body-color-rgb), 0.1);
    top: 50%;
    left: 10%;
    transform: translateY(-50%);
}

.card-with-bg-icon.bg-vico-spring::after {
    content: '\\f4d8'; /* کد یونیکد برای las la-seedling */
}

.card-with-bg-icon.bg-vico-summer::after {
    content: '\\f185'; /* کد یونیکد برای las la-sun */
}

.card-with-bg-icon.bg-vico-autumn::after {
    font-family: "Line Awesome Brands" !important;
    font-weight: 400 !important;
    content: '\\f785'; /* کد یونیکد برای las la-canadian-maple-leaf */
}

.card-with-bg-icon.bg-vico-winter::after {
    content: '\\f2dc'; /* کد یونیکد برای las la-snowflake */
}

.card-with-bg-icon.bg-icon-quote::after {
    content: '\\f10e'; /* کد یونیکد برای آیکون las la-quote-right */
}

a[data-bs-toggle="collapse"] i {
    transition: transform 0.3s ease-in-out;
}

/* ۲. وقتی دکمه باز شد (aria-expanded="true")، آیکون را ۱۸۰ درجه بچرخان */
a[data-bs-toggle="collapse"][aria-expanded="true"] i {
    transform: rotate(180deg);
}

.datatable-table {
    margin-bottom: 0;
}

.datatable-pagination ul {
    display: flex;
    padding-right: 0;
}

.datatable-pagination-list-item.datatable-hidden {
    visibility: visible !important;
    display: list-item !important;
    pointer-events: none;
    cursor: default;
}

.has-selected .selectr-label,
.selectr-placeholder {
    margin-right: 2rem;
}

.selectr-selected {
    --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
    background-color: var(--bs-card-bg);
    background-repeat: no-repeat;
    background-position: right 0.95rem center;
    background-size: 16px 12px;
}

.selectr-selected::before {
    opacity: 0;
}

.selectr-selected:focus-visible {
    outline: none;
}

.selectr-option.active {
    background-color: var(--bs-table-head-bg);
}

.selectr-option.selected {
    background-color: var(--bs-border-color);
}

.selectr-notice {
    background-color: var(--bs-table-head-bg);
    border: 0;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gDAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,wDAAwD;AAC5D;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sJAAsJ;AAC1J;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mCAAmC;AACvC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,8CAA8C;IAC9C,+CAA+C;AACnD;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;;;;;;;;;IAUI,mCAAmC;AACvC;;AAEA;;;;IAII,0CAA0C;AAC9C;;AAEA;IACI;AACJ;;AAEA;;IAEI,8CAA8C;AAClD;;AAEA;IACI,8CAA8C;IAC9C,iDAAiD;IACjD,sDAAsD;IACtD,0DAA0D;AAC9D;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;;AAGA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,0CAA0C;IAC1C,QAAQ;IACR,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB,EAAE,mCAAmC;AACzD;;AAEA;IACI,gBAAgB,EAAE,8BAA8B;AACpD;;AAEA;IACI,6CAA6C;IAC7C,2BAA2B;IAC3B,gBAAgB,EAAE,8CAA8C;AACpE;;AAEA;IACI,gBAAgB,EAAE,oCAAoC;AAC1D;;AAEA;IACI,gBAAgB,EAAE,4CAA4C;AAClE;;AAEA;IACI,sCAAsC;AAC1C;;AAEA,yEAAyE;AACzE;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,oBAAoB;IACpB,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,gEAAwR;IACxR,mFAAmF;IACnF,mCAAmC;IACnC,4BAA4B;IAC5B,yCAAyC;IACzC,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,yCAAyC;IACzC,SAAS;AACb","sourcesContent":["* {\r\n    font-family: 'Vazirmatn', serif;\r\n    -webkit-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n}\r\n\r\n.rtl {\r\n    direction: rtl !important;\r\n}\r\n\r\n.ltr {\r\n    direction: ltr !important;\r\n}\r\n\r\n.auth-logo {\r\n    content: url('images/vico-logo.svg');\r\n    max-height: 8em;\r\n}\r\n\r\n.navbar-nav {\r\n    padding-inline-start: 0;\r\n}\r\n\r\n.startbar {\r\n    border-right: 0;\r\n    border-left: 1px solid var(--bs-startbar-e-border-color);\r\n}\r\n\r\n.nav-item .nav-link span {\r\n    margin-right: 16px;\r\n}\r\n\r\n.form-check-input {\r\n    float: right !important;\r\n    margin-left: 0.5em !important;\r\n    cursor: pointer;\r\n}\r\n\r\n.form-check-label {\r\n    cursor: pointer;\r\n}\r\n\r\n.form-switch {\r\n    padding-left: 0;\r\n}\r\n\r\n.modal-header .btn-close {\r\n    margin: calc(-0.5 * var(--bs-modal-header-padding-y)) auto calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x));\r\n}\r\n\r\n.modal-body p {\r\n    text-align: justify;\r\n}\r\n\r\n#page-content {\r\n    transition: opacity 0.2s ease-out;\r\n}\r\n\r\n.page-is-fading {\r\n    opacity: 0;\r\n}\r\n\r\n.managed-alert {\r\n    transition: opacity 0.2s ease-out;\r\n}\r\n\r\n.alert-hidden {\r\n    opacity: 0;\r\n    pointer-events: none;\r\n}\r\n\r\n.profile-avatar {\r\n    height: 128px;\r\n    width: 128px;\r\n    background-color: var(--bs-card-bg);\r\n}\r\n\r\n.vico-animation {\r\n    transition: opacity 0.2s ease-out;\r\n}\r\n\r\n.uppy-Dashboard-inner {\r\n    background-color: var(--bs-card-bg) !important;\r\n    border-color: var(--bs-border-color) !important;\r\n}\r\n\r\n.uppy-Dashboard-AddFiles-title {\r\n    color: var(--bs-body-color) !important;\r\n}\r\n\r\n.uppy-Dashboard-inner {\r\n    width: auto !important;\r\n}\r\n\r\n.uppy-Dashboard-browse,\r\n.uppy-StatusBar-actionBtn--done,\r\n.uppy-DashboardTab-iconMyDevice,\r\n.uppy-Dashboard-serviceMsg-actionBtn,\r\n[data-uppy-theme=dark] .uppy-DashboardContent-addMore,\r\n[data-uppy-theme=light] .uppy-DashboardContent-addMore,\r\n[data-uppy-theme=dark] .uppy-DashboardContent-back,\r\n[data-uppy-theme=dark] .uppy-DashboardContent-save,\r\n[data-uppy-theme=light] .uppy-DashboardContent-back,\r\n[data-uppy-theme=light] .uppy-DashboardContent-save {\r\n    color: var(--bs-primary) !important;\r\n}\r\n\r\n[data-uppy-theme=dark] .uppy-Dashboard-browse:focus,\r\n[data-uppy-theme=dark] .uppy-Dashboard-browse:hover,\r\n.uppy-ProviderBrowserItem-checkbox:focus,\r\n.uppy-Dashboard-dropFilesHereHint {\r\n    border-color: var(--bs-primary) !important;\r\n}\r\n\r\n.uppy-ProviderBrowserItem-checkbox:focus {\r\n    box-shadow: 0 0 0 3px #0d6efd33\r\n}\r\n\r\n[data-uppy-theme=dark] .uppy-DashboardContent-bar,\r\n[data-uppy-theme=dark] .uppy-StatusBar {\r\n    background-color: var(--bs-card-bg) !important;\r\n}\r\n\r\n.uppy-Root {\r\n    --uppy-c-primary: var(--bs-primary) !important;\r\n    --uppy-c-bg-primary: var(--bs-card-bg) !important;\r\n    --uppy-c-text-primary: var(--bs-body-color) !important;\r\n    --uppy-c-border-primary: var(--bs-border-color) !important;\r\n}\r\n\r\n.bg-vico-spring {\r\n    background-color: #0da684A0;\r\n}\r\n\r\n.bg-vico-summer {\r\n    background-color: #fff700A0;\r\n}\r\n\r\n.bg-vico-autumn {\r\n    background-color: #db8814A0;\r\n}\r\n\r\n.bg-vico-winter {\r\n    background-color: #41cbd8A0;\r\n}\r\n\r\n.bg-card-quote {\r\n    background-color: #5b58e680;\r\n}\r\n\r\n.quote-footer::before {\r\n    content: \"— \";\r\n    opacity: 0.8;\r\n}\r\n\r\n\r\n.card-with-bg-icon {\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n.card-with-bg-icon .card-body,\r\n.card-with-bg-icon .card-header {\r\n    position: relative;\r\n    z-index: 1;\r\n    background-color: transparent;\r\n}\r\n\r\n.card-with-bg-icon::after {\r\n    font-family: \"Line Awesome Free\";\r\n    font-weight: 900;\r\n    position: absolute;\r\n    z-index: 0;\r\n    font-size: 10rem;\r\n    color: rgba(var(--bs-body-color-rgb), 0.1);\r\n    top: 50%;\r\n    left: 10%;\r\n    transform: translateY(-50%);\r\n}\r\n\r\n.card-with-bg-icon.bg-vico-spring::after {\r\n    content: '\\f4d8'; /* کد یونیکد برای las la-seedling */\r\n}\r\n\r\n.card-with-bg-icon.bg-vico-summer::after {\r\n    content: '\\f185'; /* کد یونیکد برای las la-sun */\r\n}\r\n\r\n.card-with-bg-icon.bg-vico-autumn::after {\r\n    font-family: \"Line Awesome Brands\" !important;\r\n    font-weight: 400 !important;\r\n    content: '\\f785'; /* کد یونیکد برای las la-canadian-maple-leaf */\r\n}\r\n\r\n.card-with-bg-icon.bg-vico-winter::after {\r\n    content: '\\f2dc'; /* کد یونیکد برای las la-snowflake */\r\n}\r\n\r\n.card-with-bg-icon.bg-icon-quote::after {\r\n    content: '\\f10e'; /* کد یونیکد برای آیکون las la-quote-right */\r\n}\r\n\r\na[data-bs-toggle=\"collapse\"] i {\r\n    transition: transform 0.3s ease-in-out;\r\n}\r\n\r\n/* ۲. وقتی دکمه باز شد (aria-expanded=\"true\")، آیکون را ۱۸۰ درجه بچرخان */\r\na[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"] i {\r\n    transform: rotate(180deg);\r\n}\r\n\r\n.datatable-table {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.datatable-pagination ul {\r\n    display: flex;\r\n    padding-right: 0;\r\n}\r\n\r\n.datatable-pagination-list-item.datatable-hidden {\r\n    visibility: visible !important;\r\n    display: list-item !important;\r\n    pointer-events: none;\r\n    cursor: default;\r\n}\r\n\r\n.has-selected .selectr-label,\r\n.selectr-placeholder {\r\n    margin-right: 2rem;\r\n}\r\n\r\n.selectr-selected {\r\n    --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23d9e1ec%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e\");\r\n    background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);\r\n    background-color: var(--bs-card-bg);\r\n    background-repeat: no-repeat;\r\n    background-position: right 0.95rem center;\r\n    background-size: 16px 12px;\r\n}\r\n\r\n.selectr-selected::before {\r\n    opacity: 0;\r\n}\r\n\r\n.selectr-selected:focus-visible {\r\n    outline: none;\r\n}\r\n\r\n.selectr-option.active {\r\n    background-color: var(--bs-table-head-bg);\r\n}\r\n\r\n.selectr-option.selected {\r\n    background-color: var(--bs-border-color);\r\n}\r\n\r\n.selectr-notice {\r\n    background-color: var(--bs-table-head-bg);\r\n    border: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
